import { render, staticRenderFns } from "./check-list-detailt-task.vue?vue&type=template&id=ebae8e6a&scoped=true"
import script from "./check-list-detailt-task.vue?vue&type=script&lang=js"
export * from "./check-list-detailt-task.vue?vue&type=script&lang=js"
import style0 from "./check-list-detailt-task.vue?vue&type=style&index=0&id=ebae8e6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebae8e6a",
  null
  
)

export default component.exports